import React from "react";
import { selectUser } from "modules/auth/redux/selectors";
import { useSelector } from "react-redux";
import { selectCurrentUserPreferences } from "modules/userPreferences/redux/selectors";
import { selectCurrentRoom } from "store/rooms";
import useMiroBoard from "modules/whiteboard/hooks/useMiroBoard";
import useRoomWhiteboardActions from "./hooks/useRoomWhiteboardActions";

const RoomWhiteboardSubscriber = () => {
  const { subscribe, unsubscribe } = useRoomWhiteboardActions();
  const user = useSelector(selectUser);
  const room = useSelector(selectCurrentRoom);
  const preferences = useSelector(selectCurrentUserPreferences);
  const roomId = room ? room.id : "";
  const { setMiroBoardDetails } = useMiroBoard(roomId, true);

  React.useEffect(() => {
    if (!user || !room) return;

    subscribe({
      userId: user.id,
      roomId: room.id,
      showNotification: !!(
        preferences && preferences.disableWhiteboardInitialDialog
      ),
    });
    setMiroBoardDetails();

    // eslint-disable-next-line consistent-return
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, roomId, setMiroBoardDetails]);

  return null;
};

export default RoomWhiteboardSubscriber;
